import { ISMSRepositoryType } from "../../adapters/driven/repositories/smsRepository";

export const SMSServiceImplFactory = ({
  smsRepository,
}: {
  smsRepository: ISMSRepositoryType;
}): ISMSService => {
  const sendOTP: ISendOTPService = async (payload) => {
    try {
      const response = await smsRepository.sendOTP({
        phoneNumber: payload.phone_number,
      });

      return {
        success: response.status,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const verifyOTP: IVerifyOTPService = async (payload) => {
    try {
      const response = await smsRepository.verifyOTP({
        uniqueRequestId: payload.uniqueRequestId,
        otp: payload.otp,
      });
      return {
        success: response.message === "OTP Verified!",
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const savePhoneNumber: ISavePhoneNumberService = async (payload) => {
    try {
      const response = await smsRepository.saveNumber({
        phoneNumber: payload.phone_number,
      });
      return {
        success: response.success,
        message: response.data.message,
        phone_number: response.data.phone_number,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getPhoneNumber: IGetPhoneNumberService = async () => {
    const response = await smsRepository.getPhoneNumber();
    return {
      success: true,
      data: {
        phoneNumber: response.phoneNumber,
        isVerified: response.isVerified,
      },
    };
  };

  return {
    sendOTP,
    verifyOTP,
    savePhoneNumber,
    getPhoneNumber,
  };
};
